import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Img } from 'react-image';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 65px;
  align-items: center;
`;

const Image = styled(Img)`
  width: 250px;
  height: 222px;
`;

const SupportText = styled.div`
  margin-top: 20px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 20px;
  text-align: center;
  text-transform: uppercase;
  width: 334px;
`;

const Text = styled.div`
  margin-top: 20px;
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 19px;
  text-align: center;
  width: 334px;
`;

const Separator = styled.div`
  height: 0;
  width: 335px;
  border: 1px solid ${props => props.theme.primaryColor};
  margin-top: 16px;
`;

export default function MobileDraft({ mobileImageUrl }) {
  return (
    <Container>
      <Image src={mobileImageUrl} />
      <SupportText>Support for mobile is just around the corner</SupportText>
      <Separator />
      <Text>
        Please view on desktop or tablet while we put the finishing
        touches on support for smaller devices.
      </Text>
    </Container>
  );
}

MobileDraft.propTypes = {
  mobileImageUrl: PropTypes.string.isRequired,
};
